// removed by extract-text-webpack-plugin
module.exports = {"main":"_1ST1qeEW38nehWwd2am43o","avatar":"_1zDMLL8lFIfu_Xt_nz6MvM","image":"_3WgD3xezOgpvPTmFFA-Hoj","content":"_3pFyzHZwuk2yELimtVacs-","citation":"_3qvPEwXpd6eemAWaOri9y1"};


//////////////////
// WEBPACK FOOTER
// ./components/SignupCustomerQuote.module.css
// module id = 2374
// module chunks = 1